import {useQuery} from "react-query";
import groupService from "../../services/GroupService";
import {GroupSearchRequest} from "../../models/group";

export default function useGroups(request?: GroupSearchRequest) {
   return useQuery(['groups', request], () => groupService.search(request));
}